import ZModal from "@atoms/ZModal";
import ZForm from "../ZForm";
import Col from "antd/lib/col";
import Row from "antd/lib/row";
import React, { useState } from "react";
import ZMessage from "@molecules/ZMessage";
import ZTooltip from "@atoms/ZTooltip";
import ZTypography from "@atoms/ZTypography";
import { IMissingDetailsModalTemplateProps } from "./interface";
import Form from "antd/lib/form";
import {
	IFormSectionProps,
	IFormProps,
	IFormFieldProps,
	EWidgets
} from "../ZForm/interface";
import {
	IMissingDetailsFormValues,
	IMissingDetailsModalProps
} from "./interface";
import { capitalizeFirstLetter } from "@/Contracts/Utils";

const { ZText } = ZTypography;

export const MissingDetailsModal: React.FC<
	IMissingDetailsModalProps
> = props => {
	const [form] = Form.useForm();
	const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

	const submitHandler = async (values: IMissingDetailsFormValues) => {
		const allEmails = new Set(
			Object.values(values).map(value => value.email)
		);
		const isUniqueEmails = allEmails.size === Object.keys(values).length;
		if (isUniqueEmails && props?.onSubmit) {
			setIsSubmitting(true);
			const payload = Object.keys(values).map(id => ({
				id,
				entity: { ...values[id] }
			}));
			await props?.onSubmit(payload);
			form.resetFields();
			setIsSubmitting(false);
		} else {
			ZMessage.error(
				"Another contact with the same email id is already present in this client."
			);
		}
	};

	const cancelHandler = () => {
		form.resetFields();
		props.onCancel && props.onCancel();
	};

	const customFields: IFormFieldProps[] =
		props.missingEmailKeys.map<IFormFieldProps>(missingClientContact => ({
			key: `${missingClientContact.id}.email`,
			widget: EWidgets.INPUT,
			required: true,
			message: "Email is required",
			label:
				missingClientContact.name.length > 33 ? (
					<ZTooltip
						title={missingClientContact.name}
						placement="bottom"
					>
						<ZText>{`${capitalizeFirstLetter(
							missingClientContact.name
						).substr(0, 33)}...`}</ZText>
					</ZTooltip>
				) : (
					capitalizeFirstLetter(missingClientContact.name)
				),
			widgetProps: { placeholder: "Enter email", width: "full" },
			rules: [
				{
					type: "email",
					message: "Please enter a valid email address"
				}
			],
			className: "w-full",
			normalize: value => value.trim()
		}));

	const formSections: Array<IFormSectionProps> = [
		{
			meta: {
				formItemLayout: [10, 14],
				fields: customFields
			}
		}
	];

	const formProps: IFormProps = {
		form: form,
		onFinish: submitHandler,
		sections: formSections,
		key: "MissingDetailsForm",
		submitButtonText: "Update",
		isCancelAllowed: true,
		cancelButtonText: "Cancel",
		onCancel: cancelHandler,
		layout: "horizontal",
		isRightFooter: true,
		requiredMark: false,
		loading: isSubmitting
	};

	return (
		<MissingDetailsModalTemplate
			formProps={formProps}
			visible={props.visible}
			title={props.title}
			subtitle={props.subtitle}
			onCancel={cancelHandler}
		/>
	);
};

const MissingDetailsModalTemplate: React.FC<
	IMissingDetailsModalTemplateProps
> = props => {
	return (
		<ZModal
			hideDefaultFooter
			title={props?.title}
			visible={props.visible}
			onCancel={props.onCancel}
			size="md"
		>
			<ZText className="text-gray-7">{props.subtitle}</ZText>
			<Row className="mt-6 mb-4">
				<Col span={10} className="font-bold">
					Recipient’s Name
				</Col>
				<Col span={14} className="font-bold">
					Email
				</Col>
			</Row>
			<ZForm {...props.formProps} />
		</ZModal>
	);
};

export default MissingDetailsModal;
